module.exports = __webpack_public_path__ + "img/strip_a+.21e5befd.jpg";